import React, { Component } from "react";
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge
} from "reactstrap";
import { GoTerminal, GoKebabVertical } from "react-icons/go";
import {
  FiLogOut,
  FiChevronsDown,
  FiChevronsUp,
  FiPlay,
  FiToggleLeft,
  FiToggleRight
} from "react-icons/fi";

import "./header.css";

class CompileJS extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    let code = this.worker_code.toString();
    code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
    const blob = new Blob([code], { type: "application/javascript" });
    this.worker = new Worker(URL.createObjectURL(blob));
  };

  componentWillUnmount() {
    this.worker && this.worker.terminate();
    //this.worker.removeEventListener("message");
  }

  worker_code() {
    const __utils = (() => {
      const MAX_LOGS_SIZE = 64 * 1024;

      let logs = [];
      function flushLogs() {
        if (logs.length) {
          postMessage({
            type: "LOG",
            data: logs.join("\n")
          });
          logs = [];
        }
      }

      const oldLog = this.console.log.bind(this.console);
      this.console.log = function proxyConsole(...args) {
        logs.push(args.map(arg => JSON.stringify(arg)).join(" "));
        //this removes the quotes in each line, but it prints undefined as the last line
        //logs.push(args.map(arg => arg + ""));
        if (logs.join("\n").length > MAX_LOGS_SIZE) {
          flushLogs();
        }
        return oldLog(...args);
      };

      function postResult(data) {
        flushLogs();
        postMessage(data);
      }

      return {
        postResult
      };
    })();
    this.addEventListener("message", e => {
      if (!e) return;
      var result = new Function(e.data)();
      //console.log(result);
      __utils.postResult({
        pass: true
      });
    });
  }

  fetchWebWorker = () => {
    var code = `"use strict"
    const numbers = [4, 9, 3]
    console.log(numbers.length)`;

    this.worker.postMessage(code);

    this.worker.addEventListener("message", event => {
      console.log(event.data);
    });
  };

  handleJSCode = () => {
    const jscode = this.props.handleJSCode();
    //console.log("compile-js -> jscode: ", jscode);
    this.worker.postMessage(jscode);

    this.worker.addEventListener("message", event => {
      //console.log(event.data);
      this.props.setJSOutput(event.data);
    });
  };

  render() {
    //console.log("CompileJS render -> jscode: ", this.props.jscode);
    return (
      <div
        className="sub-header-container border rounded"
        // style={{ width: "100%" }}
      >
        {/* <div className="rt-sub-header-filename-container">
          <p className="text-start rt-sub-header-menu-items">
            {this.props.fileName}
          </p>
        </div>
        <div className="rt-sub-header-buttons-container">
          <Button color="link" onClick={this.handleJSCode}>
            <FiPlay className="p-0 logo-style-dark" size={20} />
          </Button>
        </div> */}

        <p className="text-start rt-sub-header-menu-items">
          {this.props.fileName}
        </p>
        <ButtonGroup>
          <Button
            size="sm"
            color="link"
            onClick={() => this.props.handleThemeClick("vs-light")}
            active={this.props.theme === "vs-light"}
          >
            <Badge
              color={this.props.theme === "vs-light" ? "dark" : "light"}
              style={{ fontSize: "12px", fontWeight: "normal" }}
            >
              Light
            </Badge>
          </Button>
          <Button
            size="sm"
            color="link"
            onClick={() => this.props.handleThemeClick("vs-dark")}
            active={this.props.theme === "vs-dark"}
          >
            <Badge
              color={this.props.theme === "vs-light" ? "light" : "dark"}
              style={{ fontSize: "12px", fontWeight: "normal" }}
            >
              Dark
            </Badge>
          </Button>
        </ButtonGroup>
        <Button color="link" onClick={this.handleJSCode}>
          <FiPlay className="p-0 logo-style-dark" size={20} />
        </Button>
      </div>
    );
  }
}

export default CompileJS;
